export class FichaResponse {
    httpStatus : number;
    response : {
      id : string,
      codeResponse :  string,
      response : string,
      list : [
        {
           autores : [
            {
               alternativo :  string ,
               apellidoP :  string ,
               appelidoM :  string ,
               id_autor :  string ,
               nombre :  string 
            }
          ],
           descripcion :  string ,
           directorio :  string ,
           id_documental :  string ,
           id_formato :  string ,
           temaDesc :  string ,
           tipo :  string ,
           titleSeccion :  string ,
           titulo :  string ,
           url :  string ,
           urlBasic :  string ,
           url_imagen_libro :  string 
        }
      ]
    }
    constructor(){
        this.httpStatus = 0;
        this.response = {
        id : "",
        codeResponse :  "",
        response : "",
        list : [
            {
            autores : [
                {
                alternativo :  "" ,
                apellidoP :  "" ,
                appelidoM :  "" ,
                id_autor :  "" ,
                nombre :  ""
                }
            ],
            descripcion :  "" ,
            directorio :  "" ,
            id_documental :  "" ,
            id_formato :  "" ,
            temaDesc :  "" ,
            tipo :  "" ,
            titleSeccion :  "" ,
            titulo :  "" ,
            url :  "" ,
            urlBasic :  "" ,
            url_imagen_libro :  "" 
            }
        ]
        }
    }
}
